<template>
    <div v-if="renderComponent">
        <div class="flex w-full items-center justify-center">
            <!-- <div v-if="selected.itineraire">
        <ItineraireInfo :title="selected.title" />
      </div> -->
            <a v-if="selected.link" @click="ping_ads(selected.id, true)"
                class="flex items-center border border-gray-300 dark:border-slate-500 pl-4 bg-white dark:bg-transparent text-sm umami--click--ads-link"
                :class="style" :style="iOsWidth" :href="selected.link" :aria-label="selected.type"
                :alt="selected.description" target="_blank">
                <img v-if="selected.image" :src="selected.image" :alt="selected.type" class="p-1 -ml-2" width="30px"
                    height="30px" />
                <div v-else-if="selected.emoji" class="text-2xl">
                    {{ selected.emoji }}
                </div>
                <div v-if="selected.image || selected.emoji" class="ml-1 w-full">
                    {{ selected.title }}
                </div>
                <div v-else class="w-full">
                    {{ selected.title }}
                </div>
            </a>
            <div v-else-if="selected.title"
                class="flex items-center border-2 border-gray-300 dark:border-slate-500 pl-4 bg-white dark:bg-transparent text-sm umami--click--info-link"
                :class="style" :style="iOsWidth" :alt="selected.description" target="_blank">
                <img v-if="selected.image" :src="selected.image" :alt="selected.type" class="p-1 -ml-2" width="30px"
                    height="30px" />
                <div v-else-if="selected.emoji" class="text-2xl">
                    {{ selected.emoji }}
                </div>
                <div class="ml-1 w-full">
                    {{ selected.title }}
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
.boder-2 {
    border-width: 1px;
}
</style>
<script>
import shuffle from "lodash.shuffle";
import MobileDetect from "mobile-detect";

import ItineraireInfo from "@/components/itineraire/ItineraireInfo.vue";

export default {
    name: "Infos",
    props: {
        size: String,
    },
    components: {
        ItineraireInfo,
    },
    data() {
        return {
            session: null,
            style: "",
            styles: {
                small: ["w-1/4", "rounded-full"],
                medium: ["w-auto", "px-4", "rounded-full"],
                large: ["w-full", "rounded-full"],
                xl: ["w-full", "rounded-lg", "p-2"],
            },
            newsInfo: {
                itineraire: true,
                title: "🌟 Nouveau : Rechercher un itinéraire",
            },
            // Desactivate temporary
            iOsWidth: null,
            renderComponent: true,
            pwa: {
                image: "/images/info.svg",
                link: null,
                title: "Ajoute T2c.app à ton écran d'accueil",
                description: "Lien de T2c.app",
                type: "publicité",
            },
            android: {
                image: "/images/playstore.png",
                link: "https://play.google.com/store/apps/details?id=org.t2c.app&hl=fr",
                title: "Télécharge l'application !",
                id: "933e3f9b-2e0e-41ef-90fe-c7d35f96ce58",
                description: "Lien de T2c.app",
                type: "publicité",
            },
            share: {
                image: "/images/playstore.png",
                link: "https://play.google.com/store/apps/details?id=org.t2c.app&hl=fr",
                title: "Vous aimez l'appli ? Dites le nous 😉",
                id: "21741a23-c2f9-4d46-8799-99dd6cb70b3c",
                description: "Lien de T2c.app",
                type: "publicité",
            },
            instagram: {
                image: "/images/instagram.png",
                link: "https://www.instagram.com/t2c.app/",
                title: "Retrouve t2c.app sur Instagram 😉",
                id: "01b96057-844c-4e2b-806b-f47970808f71",
                description: "Lien du Instagram de t2c.app",
                type: "publicité",
            },
            facebook: {
                image: "/images/facebook.png",
                link: "https://www.facebook.com/t2capp/",
                title: "Retrouve t2c.app sur Facebook 😉",
                id: "034f5a4c-329e-4d6c-808e-b895bc906543",
                description: "Lien du Facebook de t2c.app",
                type: "publicité",
            },
            selected: {
                image: "",
                link: "",
                title: "",
                description: "",
                type: "",
            },
            ads: {
                global: [
                    // {
                    //   emoji: '💛',
                    //   link: 'https://www.paypal.com/paypalme/camtosh/5',
                    //   title: "T2C.app a besoin de vous !",
                    //   description: "T2C.app a besoin de vous !",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '💙',
                    //   link: 'https://www.paypal.com/paypalme/camtosh/5',
                    //   title: "Nous sommes bénévoles",
                    //   description: "Nous sommes bénévoles",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '💸',
                    //   link: 'https://www.paypal.com/paypalme/camtosh/5',
                    //   title: "L'appli coûte 200€ / an",
                    //   description: "L'appli coûte 200€ / an",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '📈',
                    //   link: 'https://www.paypal.com/paypalme/camtosh/5',
                    //   title: "Il y'a +4 000 utilisateurs / mois",
                    //   description: "Il y'a +1 000 utilisateurs / mois",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🎁',
                    //   link: 'https://play.google.com/store/apps/details?id=org.t2c.app',
                    //   title: "Partage l'appli pour tenter de gagner un abonnement",
                    //   description: "Partage l'appli pour tenter de gagner un abonnement",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    // 	emoji: "🔧",
                    // 	link: "https://twitter.com/ToshCamille/status/1699129566420160886",
                    // 	title: "Maintenance de l'app en cours",
                    // 	description: "Maintenance de l'app en cours",
                    // 	id: "ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4",
                    // 	type: "publicite",
                    // },
                    {
                        emoji: "🚌",
                        link: "https://www.paypal.com/paypalme/camtosh/5",
                        title: "Les lignes et arrêts ont été mis à jour",
                        description: "Les lignes et arrêts ont été mis à jour",
                        id: "ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4",
                        type: "publicite",
                    },
                    // {
                    //   emoji: '😱',
                    //   link: 'https://www.t2c.fr/actu-evenements/mouvement-de-greve-jeudi-1er-septembre-2022',
                    //   title: "La T2C en grêve",
                    //   description: "La T2C en grêve",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🚶‍',
                    //   link: 'https://www.t2c.fr/actu-evenements/mouvement-de-greve-jeudi-1er-septembre-2022',
                    //   title: "Ca va te faire du bien de marcher",
                    //   description: "Ca va te faire du bien de marcher",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🚴‍',
                    //   link: 'https://www.c-velo.fr/?ref=t2c.app',
                    //   title: "Y'a les CVelo sinon",
                    //   description: "Y'a les CVelo sinon",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🥙',
                    //   link: 'https://ubereats.com/feed?promoCode=eats-29twuu',
                    //   title: "5€ offert sur Uber Eats !",
                    //   description: "5€ offert sur Uber Eats !",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🥗',
                    //   link: 'https://roo.it/camillet-sna5',
                    //   title: "10€ offert sur ta prochaine commande Deliveroo !",
                    //   description: "-10€ sur ta prochaine commande Deliveroo !",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                ],
                localized: {
                    // 'Jaude': [
                    // {
                    //   emoji: '🍔',
                    //   link: 'https://ubereats.com/feed?promoCode=eats-29twuu',
                    //   title: "5€ offert sur Uber Eats !",
                    //   description: "5€ offert sur Uber Eats !",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // {
                    //   emoji: '🌯',
                    //   link: 'https://roo.it/camillet-sna5',
                    //   title: "10€ offert sur ta prochaine commande Deliveroo !",
                    //   description: "10€ offert sur vos prochaines commandes Deliveroo !",
                    //   id: 'ec0058d3-5b8c-4777-a3a8-c5ab883ec6d4',
                    //   type: 'publicite',
                    // },
                    // ]
                },
            },
            infos: [],
            timer: null,
            os: null,
            viewed_ads: [],
        };
    },
    methods: {
        refresh() {
            this.timer = setInterval(() => {
                this.infos = [];

                let infos =
                    this.$store.state.infos[this.$store.state.selected.ligne] || [];
                infos = infos
                    .map((info) => ({
                        ...info,
                        description: info.title,
                        image: "/images/info.svg",
                        link: null, // T2C 403 error
                        type: "information",
                    }))
                    .filter((info) =>
                        this.selected.title.length
                            ? this.selected.title != info.title
                            : true,
                    );

                if (infos.length) {
                    this.infos.push(...infos);
                }

                this.selected = this.chooseInfo();

                if (this.selected.id) {
                    this.ping_ads(this.selected.id);
                }
            }, 5000);
        },
        findReferrer() {
            const capitalizeFLetter = (text) =>
                text.length > 0 ? text[0].toUpperCase() + text.slice(1) : "";

            const referrers = [
                "google",
                "bing",
                "yahoo",
                "facebook",
                "twitter",
                "instagram",
            ];

            referrers.forEach((ref) => {
                if (document.referrer.search(`https?://(.*)${ref}..([^/?]*)`) === 0) {
                    return capitalizeFLettert(ref);
                }
            });

            return document.referrer || null;
        },
        ping_ads(campaign, clicked = false) {
            console.log("Ping for ads");
            if (this.viewed_ads.includes(campaign) && !clicked) {
                console.log("already viewed, abort");
                return;
            } else {
                console.log("Is first good !");
                this.viewed_ads.push(campaign);
            }

            //fetch('https://ads.bullshit.video/ads', {
            //method: 'post',
            //headers: {
            //'Accept': 'application/json',
            //'Content-Type': 'application/json'
            //},
            //body: JSON.stringify({
            //campaign,
            //clicked,
            //info: {
            //session: this.session,
            //referrer: this.findReferrer(),
            //url: document.URL,
            //navigator: {
            //language: navigator.language,
            //userAgent: navigator.userAgent,
            //isMobile: navigator.userAgent.toLowerCase().includes('mobile'),
            //os: this.os,
            //}
            //}
            //})
            //})
            //.catch(e => console.log(e));
        },
        chooseInfo() {
            /* priority :
       - info
       - localizedAds
       - Android & PWA banner with global Ads
       */
            if (this.infos.length) {
                return shuffle(this.infos).pop();
            }

            // const localizedAds =
            //   this.ads.localized[this.$store.state.selected.stations[0]] || [];
            // if (localizedAds.length) {
            //   return shuffle(localizedAds).pop();
            // }

            let defaultInfo = null;
            if (this.os === "AndroidOS") {
                defaultInfo = this.android;
            } else if (this.os !== "PWA") {
                defaultInfo = this.pwa;
            }
            // defaultInfo = this.android;
            if (this.ads.global.length) {
                // if (defaultInfo) {
                //   const adsWithDefault = [defaultInfo].concat(this.ads.global).filter(Boolean)
                //   return shuffle(adsWithDefault).pop();
                // }
                return shuffle(this.ads.global).pop();
            }

            return defaultInfo || this.share;
        },
        forceRerender() {
            this.renderComponent = false;
            this.$nextTick(() => (this.renderComponent = true));
        },
    },
    mounted() {
        this.session = Math.random().toString(36).substring(6);
        console.log(this.$store.state.selected);
        const md = new MobileDetect(window.navigator.userAgent);
        this.os = window.matchMedia("(display-mode: standalone)").matches
            ? "PWA"
            : md.os() || window.navigator.platform;

        if (this.os === "iOS") {
            this.iOsWidth = "max-width: 90%;";
        }

        // XL === Search page -> Insta on mobile
        if (this.size === "xl") {
            this.selected = this.share;

            /*
      // en attendant de réouvrir les comptes

      if(['iOS', 'PWA', 'AndroidOS'].includes(this.os)) {
        this.selected = this.instagram;
      }
      else {
       this.selected = this.facebook;
      }
      */

            if (this.selected.id) {
                this.ping_ads(this.selected.id);
            }
        } else {
            this.selected = this.chooseInfo();

            if (this.selected.id) {
                this.ping_ads(this.selected.id);
            }

            this.refresh();
        }
    },
    created() {
        this.style = this.styles[this.size || "medium"].join(" ");
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
